import { DEFAULT_PAGE_NUMBER, DEFAULT_PAGE_SIZE } from './LocalPartyMasterTable/constants';


export const buildLocalPartyMasterListFetchRequest = ({
  pageNumber = DEFAULT_PAGE_NUMBER,
  pageSize = DEFAULT_PAGE_SIZE,
  filter = {},
  sorted = {}
}) => {
  return {pageNumber,pageSize,filter: filter || {},sorted: sorted || {}
  };
};
